// extracted by mini-css-extract-plugin
module.exports = {"form":"search_product_form_form__T4WCf","form_wider":"search_product_form_form_wider__1uqGE","input":"search_product_form_input__1KUrx"};